// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {chain, PopulateApiParameter, SendDataToApi, ShareProductParameter } from "@insite/client-framework/Store/CommonHandlers/ShareProduct";
import { xngTellAFriend, XngTellAFriendModelApiParameter } from "@plumberssupply/App/Services/EmailService";

const XngPopulateApiParameter: typeof PopulateApiParameter = props => {  
    const {friendsEmailAddress, friendsName, ...parameter} = props.apiParameter.tellAFriendModel;
    const apiParameter: XngTellAFriendModelApiParameter = { 
        ...parameter, 
        friendsEmailAddress: props.parameter.friendsEmailAddress ,
        includePricing : (props.parameter as {includePricing?: boolean}).includePricing,
        includeInventory : (props.parameter as {includeInventory?: boolean}).includeInventory,
    } ;

    props.apiParameter = {
        ...apiParameter
    } as any;
};

// XNG-Changes we use any to override OOTB logic without  change/create custom Handler
const XngSendDataToApi: any = async (props: any) => {
    props.apiResult = await xngTellAFriend(props.apiParameter);
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter)
replaceInChain(chain, SendDataToApi, XngSendDataToApi)
